import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import FeatherWrapper from 'vue-feather-icons-wrapper'
Vue.use(FeatherWrapper)

import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate';
import es from 'vee-validate/dist/locale/es.json';
import { required, email, numeric, alpha_num, digits, alpha_spaces, regex, max, length } from 'vee-validate/dist/rules';
extend('email', email);
extend('numeric', numeric);
extend('required', required);
extend('alpha_num', alpha_num)
extend('alpha_spaces', alpha_spaces)
extend('digits', digits)
extend('regex', regex)
extend('max', max)
extend('length', length)
// Add a rule.
localize('es', es)
// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

import VueMask from 'v-mask'
Vue.use(VueMask);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
